const {
  NODE_ENV,
  PUBLIC_URL,
  REACT_APP_ENV,
  REACT_APP_DOMAIN,
  REACT_APP_API_URL,
  REACT_APP_BASE_URL,
  REACT_APP_NESHAN_URL,
} = process.env;

const CONFIG = {
  DEFAULT: {
    NODE_ENV,
    PUBLIC_URL,
  },
  APP: {
    BASE_URL: REACT_APP_BASE_URL as string,
    ENV: REACT_APP_ENV as 'development' | 'staging' | 'production',
    DOMAIN: REACT_APP_DOMAIN as string,
  },
  API: {
    BASE_URL: REACT_APP_API_URL as string,
  },
  MEDIA: {
    NESHAN_URL: REACT_APP_NESHAN_URL as string,
  },
} as const;

export { CONFIG };
